import styled from "styled-components"
import css from "@styled-system/css"

export const MobileOnly = styled.div`
  ${css({ display: ["block", "none"] })}
`
